import { render, staticRenderFns } from "./PreHeaderRoot.vue?vue&type=template&id=15776467"
import script from "./PreHeaderRoot.vue?vue&type=script&lang=ts"
export * from "./PreHeaderRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports